var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"AddProducerData"}},[_c('AddProducer',{attrs:{"data":_vm.is_admin_dealer}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }